import './_sticky-cta-button.scss'

const TABLET_BREAKPOINT = 680;
const isElementXPercentInViewport = function(el, percentVisible) {
  let
    rect = el.getBoundingClientRect(),
    windowHeight = (window.innerHeight || document.documentElement.clientHeight);

  return !(
    Math.floor(100 - (((rect.top >= 0 ? 0 : rect.top) / +-rect.height) * 100)) < percentVisible ||
    Math.floor(100 - ((rect.bottom - windowHeight) / rect.height) * 100) < percentVisible
  )
};

const stickyBanners = document.getElementsByClassName("sticky-banner")
function showHideCta () {
  for (let i = 0; i < stickyBanners.length; i++) {
    const stickyBanner = stickyBanners[i]

    if (window.innerWidth <= TABLET_BREAKPOINT) {
      // handles when we are in mobile

      // assume we'll only have one of these...
      const stickyCtaButtonTarget = document.getElementsByClassName('has-sticky-cta-button')[0]
      const stickyCtaButtonVisible = isElementXPercentInViewport(stickyCtaButtonTarget, 80)
      if (stickyCtaButtonVisible) {
        stickyBanner.classList.add('slide-out')
        stickyBanner.classList.remove('slide-in')
      } else {
        stickyBanner.classList.add('slide-in')
        stickyBanner.classList.remove('slide-out')
        stickyBanner.classList.add('show-sticky-banner')
      }
    } else {
      // handles when we are not in mobile
      const isPageAtTop = document.body.scrollTop + document.documentElement.scrollTop == 0;
      if (isPageAtTop) {
        stickyBanner.classList.add('slide-out')
        stickyBanner.classList.remove('slide-in')
      } else {
        stickyBanner.classList.add('slide-in')
        stickyBanner.classList.remove('slide-out')
        stickyBanner.classList.add('show-sticky-banner')
      }
    }
  }
}

document.addEventListener('scroll', (e) => {
  showHideCta()
})

showHideCta()
